import { ColumnPlainObject } from './column.plainObject';
import { TransformPlainObject } from './transform.plainObject';

export class InputPlainObject extends TransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
